import React from 'react'

const RemoveIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.49703 4C5.96703 4 4.33203 5.733 4.33203 8.416V16.584C4.33203 19.267 5.96703 21 8.49703 21H17.165C19.696 21 21.332 19.267 21.332 16.584V8.416C21.332 5.733 19.696 4 17.166 4H8.49703ZM17.165 22.5H8.49703C5.10803 22.5 2.83203 20.122 2.83203 16.584V8.416C2.83203 4.878 5.10803 2.5 8.49703 2.5H17.166C20.555 2.5 22.832 4.878 22.832 8.416V16.584C22.832 20.122 20.555 22.5 17.165 22.5Z"
        fill="#273754"
      />
      <path
        d="M7.83203 12.5H17.832"
        stroke="#004360"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default RemoveIcon
